import React, { useState } from "react";
import UserImage from "../../Assets/user.png";

const RecentOrdersOne = ({ table }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Check for errors directly
  if (table.error) {
    return <></>;
  }

  // Check for empty or invalid data
  if (!table.value || !Array.isArray(table.value) || table.value.length === 0) {
    return (
      <div className="alert alert-warning" role="alert">
        No data available to display.
      </div>
    );
  }

  const parsedColumns = JSON.parse(table.columns);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = table.value.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(table.value.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="col-12">
      <div className="card h-100">
        <div className="card-body p-24 table-body">
          <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between mb-20">
            <h6 className="mb-2 text-md mb-0" style={{color: "#4b5563"}}>
              {table.table_name || "Recent Orders"}
            </h6>
          </div>
          <div className="table-responsive scroll-sm">
            <table className="table bordered-table mb-0">
              <thead className=""
              style={{
                backgroundColor:"#3a80c2ff"
              }}>
                <tr>
                  {parsedColumns.map((column) => (
                    <th
                      key={column}
                      className="bg-transparent text-white bg-transparent text-capitalize"
                    >
                      {column.replace(/_/g, " ")}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {currentItems.map((data, idx) => (
                  <tr key={idx}>
                    {parsedColumns.map((column) => {
                      if (column.toLowerCase() === "user") {
                        return (
                          <td key={column}>
                            <div className="d-flex align-items-center">
                              <img
                                src={UserImage}
                                alt=""
                                className="flex-shrink-0 w-36-px h-36-px me-12 radius-8"
                              />
                              <span className="text-lg text-secondary-light fw-semibold flex-grow-1">
                                {data[column]}
                              </span>
                            </div>
                          </td>
                        );
                      } else if (column.toLowerCase() === "status") {
                        return (
                          <td key={column} className="text-center">
                            <span
                              className={`${
                                data.statusClass || "badge bg-secondary"
                              } px-24 py-4 rounded-pill fw-medium text-sm`}
                            >
                              {data[column]}
                            </span>
                          </td>
                        );
                      } else {
                        return <td key={column}>{data[column]}</td>;
                      }
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="pagination mt-3 d-flex justify-content-end align-items-center">
            <nav>
              <ul className="pagination">
                <li className="page-item">
                  <button
                    className="page-link border-0 text-secondary"
                    onClick={() => paginate(1)}
                    disabled={currentPage === 1}
                  >
                    &lt;&lt;
                  </button>
                </li>
                <li className="page-item">
                  <button
                    className="page-link border-0 text-secondary"
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    &lt;
                  </button>
                </li>
                {pageNumbers.map((number) => (
                  <li key={number} className="page-item">
                    <button
                      className={`page-link-focus page-link border-0 text-secondary ${
                        currentPage === number
                          ? "active text-white rounded-2"
                          : ""
                      }`}
                      onClick={() => paginate(number)}
                    >
                      {number}
                    </button>
                  </li>
                ))}
                <li className="page-item">
                  <button
                    className="page-link border-0 text-secondary"
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === pageNumbers.length}
                  >
                    &gt;
                  </button>
                </li>
                <li className="page-item">
                  <button
                    className="page-link border-0 text-secondary"
                    onClick={() => paginate(pageNumbers.length)}
                    disabled={currentPage === pageNumbers.length}
                  >
                    &gt;&gt;
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecentOrdersOne;
